import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  AddTargetedCatalogItems,
  ITargetedCatalogItem,
  targetedCatalogActionCreators,
  TargetedCatalogActionKeys
} from '..';
import { IState } from '../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { addItems } from '../targetedCatalogApi';
import { ITargetedCatalogGroup } from '../targetedCatalogInterfaces';

function* addTargetedCatalogItemsSaga(action: AddTargetedCatalogItems) {
  //yield put(targetedCatalogActionCreators.toggleItemSearch());
  const response: IApiExecuteRespone<ITargetedCatalogItem[]> = yield call(addItems, action.payload);
  const currentGroup: ITargetedCatalogGroup = yield select(
    (state: IState) => state.targetedCatalog.groups[action.payload.preseasonCatalogItemGroupId]
  );

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(targetedCatalogActionCreators.setItemGroups([{ ...currentGroup, products: response.value }]));
  }

  //yield put(targetedCatalogActionCreators.toggleItemSearch());
}

export function* watchAddTargetedCatalogItems() {
  yield takeEvery(TargetedCatalogActionKeys.ADD_TARGETED_CATALOG_ITEMS, addTargetedCatalogItemsSaga);
}
